
import Vue from  'vue'
import eventHub from '../../mixins/eventHub'
import {getBounds} from '../../utils/dom/pos.js'

export default {

    props: {
        focus: { type: Boolean, default: true }
    },

    data()
    {
        return {
            fakeScroll: !this.$root.$children[0].support.touch,
            scrollY: 0,
            has3d: !this.$root.$children[0].support.touch
        }
    },

    created()
    {
        // EVENTS
        this._onResized = this._onResized.bind(this)
        this._scrollY = this._scrollY.bind(this)

        this.eventHub.$on('window:resized', this._onResized)

        if (this.fakeScroll)
        {
            this.$root.$children[0].scroll.addOnSmoothScroll(this._scrollY)
        }
        else
        {
            this.$root.$children[0].scroll.addOnScroll(this._scrollY)
        }
    },

    mounted()
    {
        // ADD PROPERTIES
        this._contentElmt = this.$el.querySelector('.js-content')
        this._initBottom()

        // INIT DATAS
        this._onResized()
        this._scrollY(0)
        this._onLoaded()
    },

    destroyed()
    {
        this.eventHub.$off('window:resized', this._onResized)

        if (this.fakeScroll)
        {
            this.$root.$children[0].scroll.removeOnSmoothScroll(this._scrollY)
        }
        else
        {
            this.$root.$children[0].scroll.removeOnScroll(this._scrollY)
        }
    },

    methods: {

        _onResized()
        {
            // CHANGE DOM DATAS
            this.$root.$children[0].setHeight( this.fakeScroll ? this._contentElmt.offsetHeight : -1 )
        },

        _scrollY( posY )
        {
            this.scrollY = posY
            /*if (this.fakeScroll)
            {
                this._contentElmt.style.transform = `translateY(-${posY}px) translateZ(0)`
            }

            this._moveBottom(posY)*/


            if (this.focus)
            {
                if (this.fakeScroll)
                {
                    this._contentElmt.style.transform = `translateY(-${posY}px) translateZ(0)`
                }

                this._moveBottom(posY)
            }
        },

        _onLoaded()
        {
            this.eventHub.$emit('page:loaded', this)
        },



        /*
                ┌─────────────────────────────────────────────
                │
                │       BOTTOM
                │
                └─────────────────────────────────────────────
        */

        _initBottom()
        {
            this._bottomData = {
                textElmt: this.$el.querySelector('.js-nav-bottom'),
                isOut: true
            }
        },

        _moveBottom( scrollY )
        {
            const root = this.$root.$children[0]
            const scrollMax = root.height - root.windowSize[1]
            const dist = scrollMax - scrollY
            const textDist = dist * 0.5

            this._bottomData.textElmt.style.transform = `translateY(${textDist}px) translateZ(0)`
        },
    }
}
